<style scoped>
	#body {
		margin: 5px;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	}
	
	.el-form-item {
		margin-bottom: 0px;
	}
	
</style>

<template>
	<div id="body">
		<div style="box-shadow: 1px 1px 10px #DCDCDC; height: 40px; background-color: white; display: flex; flex-direction: row; align-items: center; margin: 0 10px; padding: 5px 5px 5px 20px; border-radius: 10px;">
			<el-button icon="el-icon-refresh-right" circle  @click="refresh" style="margin-right: 20px;"></el-button>
			
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>自动打印</el-breadcrumb-item>
			  <el-breadcrumb-item>平台列表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="margin-top: 10px; background-color: white; padding: 10px; margin: 10px; border-radius: 5px;">
			<div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; margin-bottom: 10px;">
				<el-form :inline="true" class="demo-form-inline">

					<el-form-item>
						<el-button type="primary" @click="onSubmit">刷新</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="danger" @click="addAdFunc">添加平台</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-table :data="tableData" ref="myTable" border  style="width: 100%" 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
				
				<el-table-column prop="id" label="编号" width="100"  align="center">
				</el-table-column>
				
				<el-table-column prop="img_url1" label="封面"   align="center">
					<template slot-scope="scope">
						<img :src="$http_host + scope.row.banner_url" style="width: 50px; height: 50px;" />
					</template>
				</el-table-column>
				
				<el-table-column prop="app_name" label="平台名"   align="center">
				</el-table-column>
				
				<el-table-column prop="run_code" label="平台编码"   align="center">
				</el-table-column>
				
				<el-table-column prop="h5_url" label="H5链接"   align="center">
				</el-table-column>
				
				
				<el-table-column prop="is_free" label="是否免费" align="center" >
					<template slot-scope="scope">
						<el-button size="mini" v-if="scope.row.is_free==1" type="danger">免费</el-button>
						<el-button size="mini" v-if="scope.row.is_free==0" type="primary">收费</el-button>
					</template>
				</el-table-column>
				
				<el-table-column prop="is_service" label="是否客服" align="center" >
					<template slot-scope="scope">
						<el-button size="mini" v-if="scope.row.is_service==1" type="danger">客服标签</el-button>
						<el-button size="mini" v-if="scope.row.is_service==0" type="primary">平台标签</el-button>
					</template>
				</el-table-column>
				
				<el-table-column prop="sorts" label="排序" align="center" >
				</el-table-column>
				
				<el-table-column prop="add_time" label="操作" align="center" >
					<template slot-scope="scope">
						<el-button size="mini" type="primary" @click="edit_func(scope)">编辑</el-button>
						<el-button size="mini" type="danger" @click="delete_func(scope)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<el-pagination background layout="prev, pager, next" :key="tableKey" :page-size="limit" @current-change="getData" :total="total" style="margin-top: 20px;"></el-pagination>
		</div>
		
		<el-dialog title="添加平台" :visible.sync="addView" v-if="addView" top="10px" width="800px" @close="addView=false">
			<addPlat></addPlat>
		</el-dialog>
		
		<el-dialog title="编辑平台" :visible.sync="editView" v-if="editView" top="10px" width="800px" @close="editView=false">
			<editPlat :form="editInfo"></editPlat>
		</el-dialog>
	</div>
</template>

<script>
	import addPlat from './addPlat.vue';
	import editPlat from './editPlat.vue';
	export default {
		name:'List',
		components:{
			addPlat, editPlat
		},
		data(){
			return {
				addView:false,
				payinOrder:{},
				addView:false,
				editView:false,
				editInfo:null,
				/* 搜索参数 */
				status:'',
				keyword:'',
				/* 表格参数 */
				tableKey:0,
				loading:false,
				limit:10,
				total:0,
				tableData: []
			}
		},
		created() {
			this.getData();
		},
		methods:{
			edit_func(scope){
				this.editInfo = scope.row;
				this.editInfo.banner_fullurl = this.$http_host + scope.row.banner_url;
				this.editView = true;
			},
			delete_func(scope){
				let _this = this;
				_this.$api.post("/System/deleteAutoPlat", {id:scope.row.id}).then(res=>{
					if(res.code == 200)
					{
						_this.tableData.splice(scope.$index, 1);
					}else{
						_this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(res=>{
				});
			},
			addAdFunc(){
				this.addView=true;
			},
			refresh(){
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/System/getAutoPlatList", {}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
				}).catch(res=>{
					that.loading = false;
				});
			},
			onSubmit(){
				this.getData();
			}
		}
	}
</script>